import { useCallback } from 'react';
import { useActor } from '@xstate/react';

import { useGlobalAppState } from '../../../../context/GlobalAppState';
import { useReorderNavigation } from '../useReorderNavigation';
import { logger } from '../utils';

export const useFinishReorder = () => {
  const { reorderMachineRef } = useGlobalAppState();
  const [state, sendReorderEvent] = useActor(reorderMachineRef);
  const { finishReorder } = useReorderNavigation();

  return useCallback(() => {
    logger.info('Finish Reorder', state.context);

    const { restaurantSlug, deliveryOrderDetail } = state.context;
    const addressId = deliveryOrderDetail?.addressId;

    finishReorder(restaurantSlug, addressId);
    sendReorderEvent({ type: 'FINISH_REORDER' });
  }, [state.context, finishReorder, sendReorderEvent]);
};
